/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_NavigationInputs */

const en_gc_home_navigation = /** @type {(inputs: Gc_Home_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const zh_gc_home_navigation = /** @type {(inputs: Gc_Home_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主导航`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Gc_Home_NavigationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_navigation = /** @type {((inputs?: Gc_Home_NavigationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_NavigationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_navigation(inputs)
	return zh_gc_home_navigation(inputs)
});
export { gc_home_navigation as "gc.home.navigation" }